import { useDispatch } from "react-redux";

import { showSuccessToast, showErrorToast } from "app/actions/toast_actions";
import { translate } from "app/filters/i18nFilter";
import type { ICampaignModalData } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import { allTrackers } from "app/services/track/track";

import { useWeeklyReportSubscription } from "../../../shared/llm-tracker-service/useLLMTrackerCampaigns";

interface ISubscribeMenuItemHook {
    handleSubscribe: (campaign: ICampaignModalData, subscribe: boolean) => void;
    isPending: boolean;
}

export const useSubscribeMenuItem = (): ISubscribeMenuItemHook => {
    const { mutate, isPending } = useWeeklyReportSubscription();
    const dispatch = useDispatch();

    const handleSubscribe = (campaign: ICampaignModalData, subscribe: boolean): void => {
        if (!campaign?.id) {
            return;
        }

        allTrackers.dispatchTrackEvent(
            "Drop Down",
            "Click",
            subscribe ? "Subscribe" : "Unsubscribe",
        );

        mutate(
            { campaignId: campaign.id, subscribe },
            {
                onSuccess: () => {
                    const toastKey = subscribe
                        ? "llmTracker.menu.subscribe.success"
                        : "llmTracker.menu.unsubscribe.success";

                    dispatch(showSuccessToast(translate(toastKey, { campaignName: campaign.name })));
                },
                onError: () => {
                    dispatch(showErrorToast(translate("llmTracker.menu.subscribe.error")));
                },
            },
        );
    };

    return { handleSubscribe, isPending };
};
